import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
  `<div>
  <h2>Trailer In Yard Pending Receive</h2>
  <h3>SOP</h3>
  <ol>
    <li>Check if the load has arrived</li>
    <li>If the load has arrived start offloading the packages</li>
    <li>If there is a delay, document the ETA of when it happen and record under notes section</li>
    <li>If you are about to offload the packages in sometime, document the estimate offload time and resolve this exception by hitting the resolve button</li>
  </ol>
</div>`
);



// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/AMXL_TRAILER_IN_YARD_PENDING_RECEIVE.jsx